/*
 * @Author: yubaolee <yubaolee@163.com> | ahfu~ <954478625@qq.com>
 * @Date: 2021-06-01 14:10:29
 * @LastEditTime: 2022-06-13 09:14:47
 * @Description:
 * @
 * @Copyright (c) 2022 by yubaolee | ahfu~ , All Rights Reserved.
*/
import Vue from 'vue'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets

// ⚡ Element UI 按需加载 — 登录页只需 6 个组件，全量导入会多拉 ~400KB JS
// 同步注册登录页需要的最小组件集
import ElForm from 'element-ui/lib/form'
import ElFormItem from 'element-ui/lib/form-item'
import ElInput from 'element-ui/lib/input'
import ElButton from 'element-ui/lib/button'
import ElCheckbox from 'element-ui/lib/checkbox'
import ElBadge from 'element-ui/lib/badge'
import ElMessage from 'element-ui/lib/message'
import ElLoading from 'element-ui/lib/loading'
import ElNotification from 'element-ui/lib/notification'
import ElMessageBox from 'element-ui/lib/message-box'
import elLocale from 'element-ui/lib/locale'
import lang from 'element-ui/lib/locale/lang/zh-CN'
// CSS 全量加载 — AsyncCssPlugin 已做异步，不阻塞渲染
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/custom-theme/index.css'

elLocale.use(lang)
Vue.use(ElForm)
Vue.use(ElFormItem)
Vue.use(ElInput)
Vue.use(ElButton)
Vue.use(ElCheckbox)
Vue.use(ElBadge)
Vue.use(ElLoading)
Vue.prototype.$message = ElMessage
Vue.prototype.$notify = ElNotification
Vue.prototype.$confirm = ElMessageBox.confirm
Vue.prototype.$alert = ElMessageBox.alert
Vue.prototype.$prompt = ElMessageBox.prompt

import '@/styles/index.scss' // global css
import { getRequest, postRequest, deleteRequest, putRequest } from './api/ajax'
import App from './App'
import router from './router'
import store from './store'

// ⚡ 关键工具函数同步挂载 — 共 ~800 行 / 压缩后 ~3KB，依赖全在首屏包里
// 异步加载会导致 111+ 个页面 mounted() 中 window.xxx 还是 undefined → TypeError → 初始化中断
import * as _globalConstUtil from '@/utils/globalConst'
import * as _requestNs from '@/utils/request'
import * as _globalReqestUtil from '@/utils/comReqest.js'
import * as _myUtil from '@/utils/index'
import * as _hvPrintNs from '@/utils/hvPrint'

window.globalConstUtil = _globalConstUtil
window.myRequest = _requestNs.default || _requestNs
window.globalReqestUtil = _globalReqestUtil
window.myUtil = _myUtil
window.hvPrint = _hvPrintNs.default || _hvPrintNs

Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.putRequest = putRequest;
Vue.config.productionTip = false

import '@/permission' // permission control

// ⚠️ 以下所有内容均为登录页不需要的，延迟到 Vue 实例化后异步加载
// 这样 app.js 和 chunk-vendors.js 只包含 Vue + ElementUI + Router + Vuex + 登录页代码

// ⚠️ 全局错误处理，防止异步加载的组件在未就绪时报错
Vue.config.errorHandler = (err, vm, info) => {
  if (err.message) {
    const ignoreErrors = [
      'getTableData',
      'activeNames',
      'collapse',
      'invalid dom',
      'Initialize failed',
      "Cannot read properties of undefined (reading 'style')",
      "indexOf is not a function",
      "reduce is not a function",
      "querySelectorAll is not a function",
      "Cannot read properties of null (reading '0')",
      "Cannot read properties of null (reading 'getAttribute')",
      "Cannot read properties of null (reading 'length')"
    ]

    if (err.message.includes("reading 'style'") && info && info.includes('TableLayout')) {
      console.warn('Element UI Table高度计算（已忽略）:', err.message)
      return
    }

    const shouldIgnore = ignoreErrors.some(keyword =>
      err.message.includes(keyword)
    )

    if (shouldIgnore) {
      console.warn('已知错误（已忽略）:', err.message)
      return
    }
  }

  console.error('Vue error:', err, info)
}

const globalIgnorePatterns = [
  "reading 'style'",
  'indexOf is not a function',
  'reduce is not a function',
  'querySelectorAll is not a function',
  "reading 'getAttribute'",
  "reading '0'",
  "reading 'length'"
]
window.addEventListener('error', (event) => {
  if (event.message && globalIgnorePatterns.some(p => event.message.includes(p))) {
    event.preventDefault()
  }
})
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason && (event.reason.message || String(event.reason))
  if (msg && globalIgnorePatterns.some(p => msg.includes(p))) {
    event.preventDefault()
  }
})

// ⚠️ 全局组件改为异步注册：这些只在特定页面使用，不需要首屏加载
Vue.component('FrmLeaveReqAdd', () => import(/* webpackChunkName: "chunk-frmleave" */ '@/views/forms/userDefine/frmLeaveReq/add'))
Vue.component('FrmLeaveReqUpdate', () => import(/* webpackChunkName: "chunk-frmleave" */ '@/views/forms/userDefine/frmLeaveReq/update'))
Vue.component('FrmLeaveReqDetail', () => import(/* webpackChunkName: "chunk-frmleave" */ '@/views/forms/userDefine/frmLeaveReq/detail'))
Vue.component('SysPrtList', () => import(/* webpackChunkName: "chunk-prtlist" */ '@/views/dlsvprint/syspdrtlist.vue'))

// ⚠️ ECharts 改为异步组件：不阻塞首屏加载
Vue.component('v-chart', () => ({
  component: Promise.all([
    import(/* webpackChunkName: "chunk-echarts" */ 'vue-echarts'),
    import(/* webpackChunkName: "chunk-echarts" */ 'echarts')
  ]).then(([VueECharts]) => VueECharts),
  loading: { render: h => h('div', '加载中...') },
}))

// ⚠️ Designer 打印设计器改为异步组件注册
Vue.component('Designer', () => ({
  component: import(/* webpackChunkName: "chunk-hiprint" */ '@/sv-print/index.js').then(m => {
    return m.Designer || m.default
  }),
  loading: { render: h => h('div', '加载中...') },
}))

// v-dialogDrag 指令同步注册，避免 VForm UMD 异步加载时组件已渲染但指令未注册
Vue.directive('dialogDrag', {
  bind(el) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    if (!dialogHeaderEl || !dragDom) return
    dialogHeaderEl.style.cursor = 'move'
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
    dialogHeaderEl.onmousedown = e => {
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop
      let styL, styT
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/px/g, '')
        styT = +sty.top.replace(/px/g, '')
      }
      document.onmousemove = function (e) {
        const l = e.clientX - disX
        const t = e.clientY - disY
        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`
      }
      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})

// 拖拽指令 — 同步注册，Layout 子组件 NoticeMsg 的 v-draggable 依赖此指令
import _dragDirective from '@/utils/drag/directive'
Vue.use(_dragDirective)

// v-form-render 异步组件注册：等待 VForm UMD 加载完成后才渲染
Vue.component('v-form-render', () => ({
  component: window.__vformReady.then(mod => {
    if (mod && mod.VFormRender) return mod.VFormRender
    return { render: h => h('div', 'VForm 加载失败') }
  }),
  loading: { render: h => h('div') },
}))

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

// ==========================================
// ⚠️ 以下全部在 Vue 实例化后异步加载
// 登录页已经渲染，后续模块在后台并行下载
// ==========================================

// --- 第一批：轻量级插件和工具（不阻塞，并行加载）---

// bootstrap/sv-print CSS
import(/* webpackChunkName: "chunk-extra-css" */ 'bootstrap/dist/css/bootstrap.min.css')
import(/* webpackChunkName: "chunk-extra-css" */ "sv-print/dist/style.css")

// VueDND 拖拽
import(/* webpackChunkName: "chunk-misc" */ 'awe-dnd').then(VueDND => {
  Vue.use(VueDND.default || VueDND)
})

// vue-contextmenu
import(/* webpackChunkName: "chunk-misc" */ 'vue-contextmenu').then(VueContextMenu => {
  Vue.use(VueContextMenu.default || VueContextMenu)
})

// vue-clipboard2 复制组件
import(/* webpackChunkName: "chunk-misc" */ 'vue-clipboard2').then(VueClipBoard => {
  Vue.use(VueClipBoard.default || VueClipBoard)
})

// v-viewer 图片预览
import(/* webpackChunkName: "chunk-viewer" */ 'v-viewer').then(ViewerModule => {
  require('viewerjs/dist/viewer.css')
  const Viewer = ViewerModule.default || ViewerModule
  Vue.use(Viewer, {
    defaultOptions: {
      zIndex: 9999,
    },
  })
  Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
  })
})

// vue-ls (hiprint 依赖)
import(/* webpackChunkName: "chunk-misc" */ 'vue-ls').then(Storage => {
  const StoragePlugin = Storage.default || Storage
  Vue.use(StoragePlugin, {
    namespace: 'hiPrint-',
    name: 'ls',
    storage: 'local',
  })
})

// --- 第二批：iconfont / 工具函数 / 全局变量 ---

// iconfont CSS（异步加载不影响登录页）
import(/* webpackChunkName: "chunk-assets" */ '@/assets/iconfont/iconfont.css')
import(/* webpackChunkName: "chunk-assets" */ '@/assets/public/css/comIconfont/iconfont.css')
import(/* webpackChunkName: "chunk-assets" */ '@/assets/public/css/workflowicon/iconfont.css')

// iconfont JS（图标字体脚本）
import(/* webpackChunkName: "chunk-assets" */ '@/assets/public/css/comIconfont/iconfont.js')
import(/* webpackChunkName: "chunk-assets" */ '@/assets/public/css/workflowicon/iconfont.js')

// 全局工具函数 — 已在顶部同步挂载到 window，无需再异步加载

// --- 第三批：重量级组件（后台并行下载）---

// vxe-table 表格组件
window.__vxeTableReady = import(/* webpackChunkName: "chunk-vxe" */ '@/plugins/vxe-table').catch(err => {
  console.error('vxe-table 加载失败:', err)
})

// hiprint 打印组件
window.HIPRINT_DISABLE_SOCKET = true
// 锁定 autoConnect，防止 vue-plugin-hiprint 模块顶层代码把它设回 true
Object.defineProperty(window, 'autoConnect', {
  get: function() { return !window.HIPRINT_DISABLE_SOCKET },
  set: function() {},
  configurable: true
})
window.__hiprintReady = import(/* webpackChunkName: "chunk-hiprint" */ './index').then(({ hiPrintPlugin }) => {
  hiPrintPlugin.disAutoConnect()
  // monkey-patch start 方法，阻止 vue-plugin-hiprint 模块自动连接
  if (window.hiwebSocket) {
    var _origStart = window.hiwebSocket.start
    window.hiwebSocket.start = function(cb) {
      if (window.HIPRINT_DISABLE_SOCKET) return
      return _origStart.call(this, cb)
    }
  }
  Vue.use(hiPrintPlugin, '$pluginName')
  window.hiPrintPlugin = hiPrintPlugin
}).catch(err => {
  console.error('hiprint 加载失败:', err)
})

// UEditor 富文本编辑器
window.__ueditorReady = import(/* webpackChunkName: "chunk-ueditor" */ '../public/ueditor/ueditor.config.js').then(() => {
  return import(/* webpackChunkName: "chunk-ueditor" */ '../public/ueditor/ueditor.all.js')
}).then(() => {
  return import(/* webpackChunkName: "chunk-ueditor" */ '../public/ueditor/lang/zh-cn/zh-cn.js')
}).then(() => {
  return import(/* webpackChunkName: "chunk-ueditor" */ '../public/ueditor/formdesign/leipi.formdesign.v4.js')
}).catch(err => {
  console.error('UEditor 加载失败:', err)
})

// VFormDesigner 表单设计器 (12.3MB)
if (window.localStorage.getItem('showcenten') === null) {
  window.localStorage.setItem('showcenten', JSON.stringify(false))
}
window.__vformReady = import(/* webpackChunkName: "chunk-vform" */ '@/lib/vform/VFormDesigner.umd.js').then(VFormDesigner => {
  require('@/lib/vform/VFormDesigner.css')
  const mod = VFormDesigner.default || VFormDesigner
  if (mod && typeof mod.install === 'function') {
    Vue.use(mod)
  } else {
    for (const key in VFormDesigner) {
      if (typeof VFormDesigner[key].install === 'function') {
        Vue.use(VFormDesigner[key])
        break
      }
    }
  }
  return mod
}).catch(err => {
  console.error('VFormDesigner 加载失败:', err)
})
